module.exports = __webpack_public_path__ + "media/images/icons/X-69b7e34b5ea981ab6ad9f4b7100406a6.svg";